import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import RichText from '@synergycms_core/components/generic/RichText';
import Stars from '@synergycms_app/components/functional/Stars';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './checkBox.js';

class CheckBox extends React.Component {
  static displayName = 'CheckBox';
  render() {
    const { config, children, theme } = this.props;
    const { richText, code, text, additionalText, additionalRichText, onChange, value, stars, id } = config;
    const { classes } = theme.styles;
    return (
      <label className={classes.checkboxLabel}>
        <input type="checkbox" id={id} className={classes.filterOptions} onChange={onChange} checked={value} tabIndex={config.tabIndex}/>
        {(richText || text || children) && <RichText config={richText}>{text || children}</RichText>}{' '}
        {stars && <Stars config={stars} />}{' '}
        {(additionalText || additionalRichText) && <RichText config={additionalRichText}>({additionalText})</RichText>}{' '}
        <span key={code} className={theme.styleGetter(config.innerStyle)} />
      </label>
    );
  }
}

export default compose(
  PropertyManager([
    'config',
    'code',
    'text',
    'additionalText',
    'onChange',
    'value',
    'stars',
    'richText',
    'additionalRichText',
    'id',
    'tabIndex'
  ]),
  withThemeJSS({ styleFile, link: true })
)(CheckBox);
